import React from 'react';
import { Star, X, Check } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { beforeAfter, benefits } from '../../data/content';
export function TransformationSection() {
  return <section className="bg-cream py-16 md:py-[84px]" data-id="element-239" data-mp="3i05f15e6nfyw">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-240" data-mp="3mwnim1xs189n">
        <SectionHeading kicker="Qué te llevas" icon={Star} title={<>
              De “la persona que pasea perros”
              <br className="hidden md:block" data-id="element-242" data-mp="jfdotppv5cm0" /> a <em data-id="element-243" data-mp="jem1t3ac0n7c">un negocio en el que se confía</em>
            </>} data-id="element-241" data-mp="3mvcg05g2i6k4" />
        <Reveal className="mt-11 overflow-hidden rounded-[22px] border border-line bg-white shadow-card" data-id="element-244" data-mp="5gntaeiozkzr">
          <table className="w-full border-collapse text-left" data-id="element-245" data-mp="9klsep80ovst">
            <thead data-id="element-246" data-mp="2q63bwm7rc3eb">
              <tr className="font-display text-[13px] font-bold uppercase tracking-[0.08em] md:text-[15px]" data-id="element-247" data-mp="2q5lc5flvz71n">
                <th scope="col" className="w-1/2 bg-[#EFE7DA] px-3.5 py-4 text-muted md:px-6" data-id="element-248" data-mp="2u6na7t42hd21">
                  Antes
                </th>
                <th scope="col" className="w-1/2 bg-forest px-3.5 py-4 text-tangerine-light md:px-6" data-id="element-249" data-mp="2c6tp386wl405">
                  Con PASEO PRO
                </th>
              </tr>
            </thead>
            <tbody data-id="element-250" data-mp="2m4pwbowpzesz">
              {beforeAfter.map(row => <tr key={row.before} className="border-t border-line text-[14.5px] md:text-base" data-id="element-251" data-mp="2m6kkdc3afn1a">
                  <td className="bg-[#FCFAF6] px-3.5 py-4 align-middle text-muted md:px-6" data-id="element-252" data-mp="30265h86ehmof">
                    <span className="flex items-center gap-3" data-id="element-253" data-mp="2v4w918klgar3">
                      <X className="h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-254" data-mp="39ubzeng7qe69" />
                      {row.before}
                    </span>
                  </td>
                  <td className="px-3.5 py-4 align-middle font-semibold text-forest md:px-6" data-id="element-255" data-mp="3iu79eoy1834p">
                    <span className="flex items-center gap-3" data-id="element-256" data-mp="3dw5soao2wfwe">
                      <Check className="h-4 w-4 shrink-0 text-tangerine" strokeWidth={3} aria-hidden="true" data-id="element-257" data-mp="3dtksdq3fi80r" />
                      {row.after}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </Reveal>
        <div className="mt-10 grid gap-[18px] md:grid-cols-3" data-id="element-258" data-mp="2khmnt3ytlrpd">
          {benefits.map(({
          icon: Icon,
          title,
          text
        }, i) => <Reveal key={title} delay={i * 0.05} className="rounded-[22px] bg-white px-6 py-7" data-id="element-259" data-mp="2pbh1nqrqvcgj" data-mpi={i}>
              <div className="mb-4 flex h-[54px] w-[54px] items-center justify-center rounded-2xl bg-forest" data-id="element-260" data-mp="2ub3ew07kospc">
                <Icon className="h-7 w-7 text-white" aria-hidden="true" data-id="element-261" data-mp="346x0e939rwj9" />
              </div>
              <h3 className="text-[21px] font-semibold leading-tight text-forest" data-id="element-262" data-mp="388ia5lkibup8">{title}</h3>
              <p className="mt-2 text-[15.5px] leading-relaxed text-muted" data-id="element-263" data-mp="3865szamkpod8">{text}</p>
            </Reveal>)}
        </div>
      </div>
    </section>;
}